import { type MutableRefObject } from 'react';

import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export const createImagePastePlugin = (
  onImageFileRef: MutableRefObject<((file: File) => void) | null>,
): Extension =>
  Extension.create({
    name: 'imagePaste',
    addProseMirrorPlugins() {
      return [
        new Plugin({
          key: new PluginKey('imagePaste'),
          props: {
            handlePaste: (view, event) => {
              if (!view.editable || !onImageFileRef.current) return false;
              const items = Array.from(event.clipboardData?.items ?? []);
              const imageFiles = items.flatMap(item => {
                const file = item.type.startsWith('image/')
                  ? item.getAsFile()
                  : null;
                return file ? [file] : [];
              });
              if (imageFiles.length === 0) return false;

              event.preventDefault();
              for (const file of imageFiles) {
                onImageFileRef.current(file);
              }
              return true;
            },
          },
        }),
      ];
    },
  });
